import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OrderAdminRepository from "../../../../repository/Admin/OrderAdminRepository";

export const getAdminOrderInsightInfo = createAsyncThunk('get_admin_order_insight_info', async (params) => {
  return await new OrderAdminRepository().getAdminOrderInsightInfo(params);
});

const slice = createSlice({
  name: "OrdersInsightInfo",
  initialState: {
    orderInsightInfo: {},
  },
  reducers: {
    setAdminOrderInsightInfo: {
      reducer: (state, action) => {
        state.adminOrderInsightInfo = action.payload;
        return state;
      },
    },
  },
  extraReducers: {
    [getAdminOrderInsightInfo.fulfilled]: (state, action) => {
      state.orderInsightInfo = action.payload;
      return state;
    },
  },
});

export const { setAdminOrderInsightInfo } = slice.actions;

export default slice.reducer;